<template>
  <div>
    <page-head
      :title="title"
      :btn-list="btnList"
      :show-back="false"
      @handleBtn="handleBtn"
    ></page-head>
    <div class="content">
      <div class="search">
        <Modal
          v-model="importModal"
          title="导入社保认证数据"
          width="660px"
          height="400px"
          :footer-hide="true"
          @on-cancel="closeModel"
        >
          <i-form>
            <row :gutter="80">
              <i-col span="8">
                <form-item label="所属区域">
                  <Cascader
                    v-model="comList1"
                    :data="communityList1"
                    placeholder="请选择"
                    clearable
                    @on-change="communityChange1"
                  ></Cascader>
                </form-item>
              </i-col>
            </row>
          </i-form>
          <!--/assets/企业导入模板.xlsx-->
          <div class="note box">
            请上传符合模板要求的社保认证文件,支持.xlsx格式
            <a
              class="download"
              href="https://py.shequyun.cn/base/mongofile/default/60597fb0747f3b0001acda64.xlsx"
              download="社保认证模板"
              >下载模板</a
            >
          </div>
          <Upload
            ref="upload"
            :show-upload-list="false"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            :headers="header"
            :action="actionuri"
            :on-success="handleSuccess"
            :on-progress="handleProgress"
            :on-error="handleError"
          >
            <Button :loading="uploadLoading" type="primary">导入数据</Button>
          </Upload>
        </Modal>
        <i-form ref="search" :model="query">
          <row :gutter="80">
            <i-col span="4">
              <form-item label="参保地区">
                <Cascader
                  v-model="comList"
                  :data="communityList"
                  placeholder="请选择"
                  clearable
                  @on-change="communityChange"
                  change-on-select
                ></Cascader>
              </form-item>
            </i-col>
            <i-col span="4">
              <form-item label="姓名" prop="userName">
                <Input
                  v-model="query.userName"
                  clearable
                  placeholder="请输入姓名"
                />
              </form-item>
            </i-col>
            <i-col span="4">
              <form-item label="身份证号" prop="idCardNO">
                <Input
                  v-model="query.idCardNO"
                  clearable
                  placeholder="请输入身份证号"
                />
              </form-item>
            </i-col>
            <i-col span="4">
              <form-item label="手机号码" prop="phoneNO">
                <Input
                  v-model="query.phoneNO"
                  clearable
                  placeholder="请输入手机号码"
                />
              </form-item>
            </i-col>
            <i-col span="4">
              <form-item label="状态" prop="status">
                <Select v-model="query.statusIndex" clearable>
                  <Option
                    v-for="item in statusList"
                    :key="item.index"
                    :value="item.index"
                    :label="item.status"
                  ></Option>
                </Select>
              </form-item>
            </i-col>
            <i-col span="4">
              <form-item label="类别" prop="type">
                <Select v-model="query.typeIndex" clearable>
                  <Option
                    v-for="item in typeList"
                    :key="item.index"
                    :value="item.index"
                    :label="item.type"
                  ></Option>
                </Select>
              </form-item>
            </i-col>
            <i-col span="4">
              <form-item label="认证时间" prop="eventtime">
                <DatePicker
                  v-model="time"
                  class="time"
                  type="daterange"
                  placeholder="请选择时间"
                ></DatePicker>
              </form-item>
            </i-col>
            <i-col span="4">
              <form-item label="认证状态" prop="status">
                <Select v-model="query.lastFaceVerify" clearable>
                  <Option
                    v-for="item in verifyList"
                    :key="item.index"
                    :value="item.index"
                    :label="item.vType"
                  ></Option>
                </Select>
              </form-item>
            </i-col>
			<i-col span="4">
			  <form-item label="认证年度" prop="faceVerifyTime">
			    <DatePicker
            format="yyyy"
			      v-model="query.faceVerifyTime"
			      class="faceVerifyTime"
			      type="year"
			      placeholder="请选择年度"
			    ></DatePicker>
			  </form-item>
			</i-col>
          </row>
        </i-form>
      </div>
      <div class="table-data">
        <i-table
          :columns="tableHeader"
          :border="true"
          :loading="isTableLoading"
          :data="tableData"
          stripe
          ref="table"
          @on-row-dblclick="handleClickDetail"
        >
          <template slot-scope="{ row, index }" slot="lastFaceVerify">
            <span
              :class="[
                row.lastFaceVerify == 1 || row.lastFaceVerify == 11
                  ? 'success'
                  : '',
              ]"
              >{{
                row.lastFaceVerify == 11
                  ? "人工认证成功"
                  : row.lastFaceVerify == null || row.lastFaceVerify == 2
                  ? "待认证"
                  : row.lastFaceVerify == 1
                  ? "认证成功"
                  : "认证失败"
              }}</span
            >
          </template>
          <template slot-scope="{ row, index }" slot="action">
            <span @click="handleClickDetail(row)" class="action">[详情]</span>
          </template>
        </i-table>
        <div class="page">
          <page
            :total="total"
            :current="pageNum"
            @on-change="pageChange"
            show-total
          />
        </div>
      </div>
    </div>
  </div>
</template>



<script>
import pageHead from "../../../components/head";
import api from "../../../api/index";
const { ssList, ssExport } = api;
const STATUSMAP = {
  0: {
    status: "正常",
  },
  1: {
    status: "暂停",
  },
  2: {
    status: "新增",
  },
  100: {
    status: "",
  },
};
const TYPEMAP = {
  0: {
    type: "居民",
  },
  1: {
    type: "民办教师",
  },
  2: {
    type: "居民&民办教师",
  },
  100: {
    type: "",
  },
};
export default {
  name: "ssv",
  components: {
    pageHead,
  },

  data() {
    return {
      statusList: [
        {
          index: 0,
          status: "正常",
        },
        {
          index: 1,
          status: "暂停",
        },
        {
          index: 2,
          status: "新增",
        },
      ],
      typeList: [
        {
          index: 0,
          type: "居民",
        },
        {
          index: 1,
          type: "民办教师",
        },
      ],
      verifyList: [
        {
          index: 0,
          vType: "认证失败",
        },
        {
          index: 11,
          vType: "人工认证成功",
        },
        {
          index: 1,
          vType: "认证成功",
        },
        {
          index: 2,
          vType: "待认证",
        },
      ],
      query: {
        communityId: "",
        userName: "",
        idCardNO: "",
        phoneNO: "",
        beginFaceVerifyTime: "",
        endFaceVerifyTime: "",
        statusIndex: "",
        typeIndex: "",
        lastFaceVerify: "",
        faceVerifyTime:''
      },
      time: "",
      communityList: [],
      communityList1: [],
      comList: [],
      comList1: [],
      isTableLoading: false,
      pageNum: 1,
      pageSize: 10,
      total: 0,
      title: "社保认证",
      btnList: [
        {
          name: "重置",
          type: "reset",
        },
        {
          name: "搜索",
          type: "search",
        },
        {
          name: "导入",
          type: "import",
        },
        {
          name: "导出",
          type: "export",
        },
      ],
      tableHeader: [
        {
          title: "序号",
          type: "index",
          width: 60,
          align: "center",
        },
        {
          title: "参保地区",
          key: "communityName",
        },
        {
          title: "姓名",
          key: "userName",
        },
        {
          title: "身份证号码",
          key: "idCardNO",
        },
        {
          title: "手机号码",
          key: "phoneNO",
        },
        {
          title: "居住地址",
          key: "address",
        },
        {
          title: "状态",
          key: "status",
        },
        {
          title: "类别",
          key: "type",
        },
        {
          title: "最后一次认证时间",
          key: "lastFaceVerifyTime",
        },
        {
          title: "最近一次认证结果",
          slot: "lastFaceVerify",
        },
        {
          title: "操作",
          slot: "action",
        },
      ],
      tableData: [],
      header: {
        token: window.sessionStorage.getItem("token"),
      },
      actionuri: "",
      uploadLoading: false,
      importModal: false,
    };
  },
  methods: {
    handleBtn(type) {
      if (type == "reset") {
        this.time = "";
        this.pageNum = 1;
        this.query.beginFaceVerifyTime = "";
        this.query.endFaceVerifyTime = "";
        this.comList = [];
        this.query.statusIndex = "";
        this.query.typeIndex = "";
        this.query.lastFaceVerify = "";
        this.query.faceVerifyTime = "";
        this.query.communityId = this.$store.state.streetorcommunityid;
        this.$refs.search.resetFields();
        this.getSSList();
      } else if (type == "search") {
        this.pageNum = 1;
        this.getSSList();
      } else if (type == "import") {
        this.importSSV();
        this.pageNum = 1;
        this.getSSList();
      } else {
        let {
          communityId,
          userName,
          idCardNO,
          phoneNO,
          beginFaceVerifyTime,
          endFaceVerifyTime,
          lastFaceVerify,
          statusIndex,
          typeIndex,
          faceVerifyTime,
        } = this.query;
        lastFaceVerify = lastFaceVerify ? lastFaceVerify : "";
        typeIndex = typeIndex ? typeIndex : "";
        statusIndex = statusIndex ? statusIndex : "";
        let url =
          ssExport +
          "?communityId=" +
          communityId +
          "&userName=" +
          userName +
          "&idCardNO=" +
          idCardNO +
          "&phoneNO=" +
          phoneNO +
          "&lastFaceVerify=" +
          lastFaceVerify +
          "&statusIndex=" +
          statusIndex +
          "&typeIndex=" +
          typeIndex +
          "&faceVerifyTime=" +
          faceVerifyTime +
          "&beginFaceVerifyTime=" +
          beginFaceVerifyTime +
          "&endFaceVerifyTime=" +
          endFaceVerifyTime +
          "&token=" +
          this.header.token;

        console.log(url);
        window.open(url);
      }
    },
    handleClickDetail(item) {
      console.log(item);
      this.$router.push({
        name: "ssvDetail",
        query: { id: item.id },
      });
    },
    pageChange(val) {
      this.pageNum = val;
      this.getSSList();
    },
    getCommunity() {
      this.$get(this.urlobj.getCommunityCascade, {
        communityId: this.$store.state.streetorcommunityid,
        nationwide: 1,
        lowestLevelId: 10000007770009,
      })
        .then((res) => {
          this.communityList = res.rows.length
            ? this.formateData(res.rows)
            : [];
          console.log(this.communityList);
        })
        .catch((e) => {
          this.$Message.error("获取行政区域失败");
        });
    },
    getCommunity1() {
      this.$get(this.urlobj.getCommunityCascade, {
        communityId: this.$store.state.streetorcommunityid,
        nationwide: 1,
        lowestLevelId: 10000007770008,
      })
        .then((res) => {
          this.communityList1 = res.rows.length
            ? this.formateData(res.rows)
            : [];
          console.log(this.communityList1);
        })
        .catch((e) => {
          this.$Message.error("获取行政区域失败");
        });
    },
    closeModel(data) {
      this.importModal = false;
    },
    importSSV() {
      var idlist = this.communityList1;
      if (this.$store.state.isJiedao == 1) {
        if (!idlist.length || idlist.length > 1) {
          this.$Message.warning("请选择一个行政区域");
          return;
        }
      }
      this.importModal = true;
    },
    formateData(data) {
      let returnData = data.map((item) => {
        return {
          value: {
            communityId: item.communityId,
            childrenIdList: item.childrenIdList,
          },
          label: item.communityName,
          children: item.children.length ? this.formateData(item.children) : [],
        };
      });
      return returnData;
    },
    communityChange(value) {
      let returndata = value[value.length - 1];
      this.query.communityId = returndata.communityId;
      console.log(this.query.communityId);
    },
    communityChange1(value) {
      let returndata = value[value.length - 1];
      this.query.communityId1 = returndata.communityId;

      let streetId = "";
      if (this.$store.state.isJiedao == 1) {
        streetId = this.query.communityId1;
      } else {
        streetId = this.$store.state.streetorcommunityid;
      }
      console.log(streetId);
      console.log(returndata);
      if (
        returndata &&
        returndata.childrenIdList.length == 0
      ) {
        if (this.actionuri.includes("?")) {
          this.actionuri = this.actionuri.substring(
            0,
            this.actionuri.indexOf("?")
          );
        }

        this.actionuri += `?streetId=${streetId}`;
        console.log("url", this.actionuri);
      }
    },
    handleProgress() {
      this.uploadLoading = true;
    },
    handleSuccess(e) {
      console.log(e);
      this.uploadLoading = false;
      this.importModal = false;
      if (e.isSucceed) {
        this.$Message.success(e.message);
        this.pageNum = 1;
        this.getSSList();
      } else {
        this.$Message.error(e.message);
      }
    },
    handleError(e) {
      console.log(e);
      this.uploadLoading = false;
      this.importModal = false;
      this.$Message.error("导入失败");
    },
    async getSSList() {
      this.isLoading = true;
      try {
        if (this.time[0]) {
          this.query.beginFaceVerifyTime = this.$util.FormatDate(
            new Date(this.time[0]),
            "yyyy-MM-dd"
          );
          this.query.endFaceVerifyTime = this.$util.FormatDate(
            new Date(this.time[1]),
            "yyyy-MM-dd"
          );
        }
        if (this.query.faceVerifyTime){
          this.query.faceVerifyTime= this.$util.FormatDate(
            new Date(this.query.faceVerifyTime),
            "yyyy"
          );
        }
        // else{
        //   this.query.faceVerifyTime= this.$util.FormatDate(
        //     new Date(),
        //     "yyyy"
        //   );
        // }
        let res = await this.$post(ssList, {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          comeType:"34",
          ...this.query,
        });
        console.log(this.query);

        let list = res.rows.map((item) => ({
          ...item,
          ...STATUSMAP[item.statusIndex != null ? +item.statusIndex : 100],
          ...TYPEMAP[item.typeIndex != null ? +item.typeIndex : 100],
        }));
        // console.log(list);
        this.tableData = list;
        this.total = res.total;
      } finally {
        this.isLoading = false;
      }
    },
  },

  created() {
    this.getCommunity();
    this.getCommunity1();
    this.query.communityId = this.$store.state.streetorcommunityid;
    this.getSSList();
    this.actionuri = this.urlobj.ssImport;
    console.log(this.$store.state.streetorcommunityid);
  },
  mounted() {},
};
</script>

<style  scoped lang="less">
.content {
  margin: 20px;
}
.search {
  width: 100%;
  background-color: white;
  border-radius: 5px;
  padding: 20px;
  margin-bottom: 20px;
}
.time {
  width: 100%;
}
.table-data {
  width: 100%;
  background-color: white;
  border-radius: 5px;
  padding: 20px;
  min-height: calc(100vh - 450px);
  .page {
    width: 100%;
    margin-top: 10px;
    display: flex;
    justify-content: center;
  }
  .success {
    color: #ff7b44;
  }
  .action {
    color: #5e6d94;
    cursor: pointer;
    margin-right: 10px;
  }
}
</style>
